import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { ApiUrls } from '../ApiUrls';
import { ICoOpCampaignType, ICoOpState } from '../lookups';
import {
  ICoOpChangeStateRequest,
  ICoOpDealerEstimate,
  ICoOpGlobalSettings,
  ICoOpRegionBudget,
  ICoOpRequest,
  ICoOpRequestApiResponse,
  ICoOpRequestStatus,
  ICoOpSalesDistrictBudget,
  INewCoOpRequest
} from './coOpInterfaces';

export async function createCoOpRequest(request: INewCoOpRequest): Promise<IEntityWithMessages<ICoOpRequest>> {
  try {
    const response = await httpService.post(ApiUrls.coOpRequests(), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpGlobalSettings(fiscalYear: string): Promise<ICoOpGlobalSettings> {
  try {
    const response = await httpService.get(ApiUrls.coOpGlobalSettings(fiscalYear));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpDealerEstiamte(
  businessEntityId: number | undefined,
  fiscalYear: string
): Promise<ICoOpDealerEstimate> {
  try {
    const response = await httpService.get(ApiUrls.coOpDealerEstiamte(businessEntityId, fiscalYear));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpRegionBudgets(fiscalYear: string): Promise<ICoOpRegionBudget[]> {
  try {
    const response = await httpService.get(ApiUrls.coOpRegionBudgets(fiscalYear));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpSalesDistrictBudgets(
  salesDistricts: string[],
  fiscalYear: string
): Promise<ICoOpSalesDistrictBudget[]> {
  try {
    const response = await httpService.get(ApiUrls.coOpSalesDistrictBudgets(salesDistricts, fiscalYear));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpRequests(
  salesDistricts: string[],
  fiscalYear: string,
  finance: boolean
): Promise<ICoOpRequestApiResponse> {
  try {
    const response = await httpService.get(ApiUrls.coOpRequests(salesDistricts, fiscalYear, finance));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchDealerCoOpRequests(accountNum: string): Promise<ICoOpRequestApiResponse> {
  try {
    const response = await httpService.get(ApiUrls.coOpDealerRequests(accountNum));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpRequest(coOpRequestId: number): Promise<ICoOpRequest> {
  try {
    const response = await httpService.get(ApiUrls.coOpRequest(coOpRequestId));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchCoOpRequestStatuses(coOpRequestId: number): Promise<ICoOpRequestStatus> {
  try {
    const response = await httpService.get(ApiUrls.coOpRequestStatuses(coOpRequestId));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpCampaignType(campaignType: ICoOpCampaignType): Promise<ICoOpCampaignType> {
  try {
    const response = await httpService.put(ApiUrls.coOpCampaignTypes(), campaignType);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpDealerEstiamte(estimate: ICoOpDealerEstimate): Promise<ICoOpDealerEstimate> {
  try {
    const response = await httpService.put(ApiUrls.coOpDealerEstiamte(), estimate);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpGlobalSettings(settings: ICoOpGlobalSettings): Promise<ICoOpGlobalSettings> {
  try {
    const response = await httpService.put(ApiUrls.coOpGlobalSettings(), settings);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpRegionBudgets(budgets: ICoOpRegionBudget[]): Promise<ICoOpRegionBudget[]> {
  try {
    const response = await httpService.put(ApiUrls.coOpRegionBudgets(), budgets);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpRequest(request: INewCoOpRequest): Promise<IEntityWithMessages<ICoOpRequest>> {
  try {
    const response = await httpService.put(ApiUrls.coOpRequests(), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpSalesDistrictBudgets(
  budgets: ICoOpSalesDistrictBudget[]
): Promise<ICoOpSalesDistrictBudget[]> {
  try {
    const response = await httpService.put(ApiUrls.coOpSalesDistrictBudgets(), budgets);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpState(state: ICoOpState): Promise<ICoOpState> {
  try {
    const response = await httpService.put(ApiUrls.coOpStates(), state);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateCoOpStatus(
  request: ICoOpChangeStateRequest
): Promise<IEntityWithMessages<ICoOpRequestStatus>> {
  try {
    const response = await httpService.post(ApiUrls.coOpStatus(), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
